/* eslint-disable react/prop-types */
import React from "react";

const FlagIcon = ({ size = 10, color = "white" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke={color} width={size} height={size}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
  </svg>
);

const LEGEND_STYLES = {
  notVisited:  { bg: "#f0f0f0", border: "#c8c8c8" },
  notAnswered: { bg: "#fff0f0", border: "#f87171" },
  answered:    { bg: "#f0fff4", border: "#4ade80" },
  marked:      { bg: "#faf5ff", border: "#c084fc" },
};
const STATUS_STYLES = {
  notVisited:     { bg: "#f0f0f0", border: "#c8c8c8", color: "#555"    },
  notAnswered:    { bg: "#fff0f0", border: "#f87171", color: "#ef4444"  },
  answered:       { bg: "#f0fff4", border: "#4ade80", color: "#16a34a"  },
  marked:         { bg: "#faf5ff", border: "#c084fc", color: "#9333ea"  },
  answeredMarked: { bg: "#faf5ff", border: "#a855f7", color: "#7c3aed"  },
  current:        { bg: "#fff5f5", border: "#f87171", color: "#ef4444"  },
};

const LegendItem = ({ label, type }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <div style={{
      width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
      border: `2px solid ${LEGEND_STYLES[type].border}`,
      backgroundColor: "transparent",
    }} />
    <span style={{ fontSize: 13, color: "#374151", whiteSpace: "nowrap", fontWeight: 400 }}>{label}</span>
  </div>
);

const AdaptiveQuestionPalette = ({
  questions = [],
  currentIndex,
  selectedAnswers = {},
  markedForReview = {},
  visitedMap = {},
  handleQuestionSelect,
}) => {


  const getStatus = (index) => {
    const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, index);
    const isMarked = markedForReview[index] === true;
    const isVisited = visitedMap[index] === true;

    if (isAnswered && isMarked) return "answeredMarked";
    if (isMarked) return "marked";
    if (isAnswered) return "answered";
    if (isVisited) return "notAnswered";
    return "notVisited";
  };

  return (
    <div style={{
      width: '100%',
      background: "#FFFFFF",
      borderRadius: 12,
      padding: '16px',
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: 12,
      fontFamily: "inherit",
    }}>

      {/* Row 1 */}
      <div style={{ display: "flex", alignItems: "center", gap: 28, flexWrap: "wrap" }}>
        <LegendItem label="Not Visited" type="notVisited" />
        <LegendItem label="Not Answered" type="notAnswered" />
        <LegendItem label="Answered" type="answered" />
      </div>

      {/* Row 2 */}
      <div style={{ display: "flex", alignItems: "center", gap: 28, flexWrap: "wrap" }}>
        <LegendItem label="Marked for Review" type="marked" />

        {/* Answered & Marked */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ position: "relative", width: 20, height: 20, flexShrink: 0 }}>
            <div style={{
              width: 20, height: 20, borderRadius: "50%",
              border: "2px solid #a855f7", backgroundColor: "transparent",
            }} />
            <div style={{
              position: "absolute", top: -5, right: -5,
              width: 16, height: 16, borderRadius: "50%",
              backgroundColor: "#7C3AED",
              display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <FlagIcon size={9} color="white" />
            </div>
          </div>
          <span style={{ fontSize: 13, color: "#374151", whiteSpace: "nowrap", fontWeight: 400 }}>Answered &amp; Marked</span>
        </div>
      </div>
      {/* Question Grid */}
      <div style={{
        display: "grid",
       gridTemplateColumns: "repeat(8, 1fr)",
        gap: 6,
        maxHeight: 210,
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        scrollbarColor: "#e5e7eb transparent",
        padding: "8px 8px 6px 8px",
      }}>
        {questions.map((_, index) => {
          const status = getStatus(index);
          const style = STATUS_STYLES[status] || STATUS_STYLES.notVisited;
          const isCurrent = currentIndex === index;
          const isAnsweredMarked = status === "answeredMarked";

          return (
            <div
              key={index}
              role="button"
              tabIndex={0}
              onClick={() => handleQuestionSelect(index)}
              onKeyDown={(e) => e.key === "Enter" && handleQuestionSelect(index)}
              style={{
                position: "relative",
                aspectRatio: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: style.bg,
                border: `1.5px solid ${isCurrent ? "#f87171" : style.border}`,
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                color: style.color,
                cursor: "pointer",
                boxShadow: isCurrent ? "0 0 0 2px #fecaca" : "0 1px 2px rgba(0,0,0,0.06)",
                userSelect: "none",
                transition: "transform 0.1s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.07)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            >
              {index + 1}
              {isAnsweredMarked && (
                <div style={{
                  position: "absolute", top: -6, right: -6,
                  width: 14, height: 14, borderRadius: "50%",
                  backgroundColor: "#7c3aed",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <FlagIcon size={8} color="white" />
                </div>
              )}
              {/* {status === "marked" && (
                <div style={{
                  position: "absolute", top: -6, right: -6,
                  width: 14, height: 14, borderRadius: "50%",
                  backgroundColor: "#c084fc",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <FlagIcon size={8} color="white" />
                </div>
              )} */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdaptiveQuestionPalette;